import React from "react";
import { connect } from "react-redux";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container-fluid d-flex justify-content-between">
        <span className="text-muted d-block text-center text-sm-start d-sm-inline-block">
          Copyright © {currentYear}
        </span>
      </div>  
    </footer>
  );
};
const mapStateToPros = (state) => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    loader: state.persistStore.loader,
    user: state.Auth,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Footer);
